import React from 'react';
import VendorBooths from './VendorBooths';

const BazaarVendorFunnel = () => {
  return <VendorBooths allowedBooths={['bazaar', 'bazaar-20x10', 'bazaar-20x20']} />;
};

export default BazaarVendorFunnel;
